
/*
 * @Author: libo 
 * @Date: 2020-11-13 17:44:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-07 14:54:22
 */

<template>
  <a-modal
    :title="title"
    :width="1000"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
          <div div class="form-contain">
            <div v-if="this.arg==1">
              <a-row :gutter="24">
                <a-col :span="21"></a-col>
                <a-col :span="3">
                  <a-button type="primary" @click="read_only()">{{ $t('读卡') }}</a-button>
                </a-col>
              </a-row>
              <a-divider orientation="left" v-if="this.model.cardTypeName==60">{{ $t('读卡信息') }}</a-divider>
              <detail-list v-if="this.model.cardTypeName==60">
                <detail-list-item :term="$t('用户卡号')">{{model.cardId}}</detail-list-item>
                <detail-list-item :term="$t('刷卡标识')">{{model.CardIdentification==1?$t('已刷卡'):$t('未刷卡')}}</detail-list-item>
                <detail-list-item :term="$t('购买次数')">{{model.BuyNumber}}</detail-list-item>
                <detail-list-item v-if="model.CardIdentification!=1" :term="$t('剩余金额')" class="label">{{model.RemainingAmount}}{{ $t('元') }}</detail-list-item>
                <detail-list-item :term="$t('累计用量')" class="label">{{model.CumulativeDosage}}m³</detail-list-item>
                <detail-list-item v-if="model.CardIdentification!=1" :term="$t('单价')" class="label">{{model.univalence}}{{ $t('元/m³') }}</detail-list-item> 
                <detail-list-item v-if="model.CardIdentification==1" :term="$t('刷卡日期')" class="label">{{model.year}}{{ $t('年') }}{{model.month}}{{ $t('月') }}{{model.day}}{{ $t('日') }}</detail-list-item>
              </detail-list>
              <a-divider orientation="left" v-if="exhibition">{{ $t('用户信息') }}</a-divider>
              <detail-list v-if="exhibition">
                <detail-list-item :term="$t('表编号')">{{data.meterId}}</detail-list-item>
                <detail-list-item :term="$t('用户编号')">{{data.userId}}</detail-list-item>
                <detail-list-item :term="$t('用户姓名')">{{data.userName}}</detail-list-item>
                <detail-list-item :term="$t('手机号码')">{{data.userPhone}}</detail-list-item>
                <detail-list-item :term="$t('表IMEI号')">{{data.meterIMEI}}</detail-list-item>
                <detail-list-item :term="$t('用户地址')">{{data.userAddr}}</detail-list-item>
                <detail-list-item :term="$t('用户所在区域名称')">{{data.userAreaName}}</detail-list-item>
                <detail-list-item :term="$t('当前余额')" class="label">{{data.userAccountNum}}{{ $t('元') }}</detail-list-item>
                <detail-list-item :term="$t('充值次数')">{{data.userPayTimes}}</detail-list-item>
                <detail-list-item :term="$t('当前表结算累计流量')" class="label">{{data.userCalNum}}m³</detail-list-item>
                <detail-list-item :term="$t('价格名称')">{{data.wtName}}</detail-list-item> 
                <detail-list-item :term="$t('合计单价')" class="label">{{data.wtTotalPrice}}{{ $t('元') }}</detail-list-item>
                <detail-list-item :term="$t('用户是否制卡')">{{data.userHasCard==0?$t('未制卡'):data.userHasCard==1?$t('已制卡'):''}}</detail-list-item> 
                <detail-list-item :term="$t('用户制卡时间')" v-if="data.userHasCard==1">{{data.userCreateCardTime}}</detail-list-item>
              </detail-list><br />
              <a-row :gutter="24" v-if="exhibition">
                <a-col :span="6"></a-col>
                <a-col :span="6">
                  <a-button type="primary" block size="large" @click="showModal(1)">
                    {{ $t('更新用户卡') }}
                  </a-button>
                </a-col>
                <a-col :span="6">
                  <a-button type="danger" block size="large" @click="showModal(3)">
                    {{ $t('用户卡充值') }}
                  </a-button>
                </a-col>
              </a-row>
            </div>
            <div v-else>
              <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
              <detail-list>
                <detail-list-item :term="$t('表编号')">{{data.meterId}}</detail-list-item>
                <detail-list-item :term="$t('用户编号')">{{data.userId}}</detail-list-item>
                <detail-list-item :term="$t('用户姓名')">{{data.userName}}</detail-list-item>
                <detail-list-item :term="$t('手机号码')">{{data.userPhone}}</detail-list-item>
                <detail-list-item :term="$t('表IMEI号')">{{data.meterIMEI}}</detail-list-item>
                <detail-list-item :term="$t('用户地址')">{{data.userAddr}}</detail-list-item>
                <detail-list-item :term="$t('用户所在区域名称')">{{data.userAreaName}}</detail-list-item>
                <detail-list-item :term="$t('当前余额')" class="label">{{data.userAccountNum}}{{ $t('元') }}</detail-list-item>
                <detail-list-item :term="$t('充值次数')">{{data.userPayTimes}}</detail-list-item>
                <detail-list-item :term="$t('当前表结算累计流量')" class="label">{{data.userCalNum}}m³</detail-list-item>
                <detail-list-item :term="$t('价格名称')">{{data.wtName}}</detail-list-item> 
                <detail-list-item :term="$t('合计单价')" class="label">{{data.wtTotalPrice}}{{ $t('元') }}</detail-list-item>
                <detail-list-item :term="$t('用户是否制卡')">{{data.userHasCard===null?$t('未制卡'):data.userHasCard==1?$t('已制卡'):data.userHasCard==0?$t('未制卡'):''}}</detail-list-item> 
                <detail-list-item :term="$t('用户制卡时间')" v-if="data.userHasCard==1">{{data.userCreateCardTime}}</detail-list-item>
              </detail-list>
              <a-divider orientation="left">{{ $t('制卡操作') }}</a-divider>
              <a-form-model ref="form" :model="form" :rules="rules">
                <a-row :gutter="24">
                  <a-col :span="12">
                    <a-form-model-item :label="$t('卡片价格(元)')" prop="cardMoney" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:160%">
                      <a-input v-model="form.cardMoney" :placeholder="$t('请输入卡片价格')" style="width:60%"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
              <a-row :gutter="24">
                <a-col :span="8"></a-col>
                <a-col :span="8">
                  <a-button type="danger" block size="large" @click="showModal(2)">
                    {{ $t('制卡') }}
                  </a-button>
                </a-col>
              </a-row>
            </div>
          </div>
          <a-modal v-model="CardInformation" centered :title="$t('确定要更新用户卡吗?')" @ok="CardInformationOk">
            <detail-list :col='2'>
              <detail-list-item :term="$t('用户编号')">{{data.userId}}</detail-list-item>
              <detail-list-item :term="$t('购买次数')">{{data.userPayTimes}}</detail-list-item>
              <detail-list-item :term="$t('剩余金额(元)')">{{data.userAccountNum}}</detail-list-item>
              <detail-list-item :term="$t('结算累计流量(m³)')" class="label">{{data.userCalNum}}</detail-list-item>
              <detail-list-item :term="$t('单价(元)')" class="label">{{data.wtTotalPrice}}</detail-list-item>
            </detail-list>
          </a-modal>
          <a-modal v-model="MakeACard" centered :title="$t('确定要制卡吗?')" @ok="MakeACardOk">
            <detail-list :col='2'>
              <detail-list-item :term="$t('用户编号')">{{data.userId}}</detail-list-item>
              <detail-list-item :term="$t('购买次数')">{{data.userPayTimes===null?0:data.userPayTimes}}</detail-list-item>
              <detail-list-item :term="$t('剩余金额(元)')">{{data.userAccountNum}}</detail-list-item>
              <detail-list-item :term="$t('结算累计流量(m³)')" class="label">{{data.userCalNum}}</detail-list-item>
              <detail-list-item :term="$t('单价(元)')" class="label">{{data.wtTotalPrice}}</detail-list-item>
              <detail-list-item :term="$t('卡片价格(元)')" class="label">{{this.form.cardMoney}}</detail-list-item>
            </detail-list>
          </a-modal>
    </a-spin>
    <card-pay-modal ref="modalForm" @ok="modalFormOk"></card-pay-modal>
  </a-modal>
  
</template>

<script>
  import { getAction,putAction,postAction } from '@/api/manage'
  import {isUndefined,isNull} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import CardPayModal from '../../meterManagement/modules/CardPayModal'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterRfidToolMgrFormForm',
    components: {
      DetailList,
      DetailListItem,
      CardPayModal
    },
    data () {
      const USB_DEF_INDEX = {
        //写卡成功
          USB_DEF_WRITESUCC : 10,
          // 写卡失败
          USB_DEF_WRITEFAIL : 11,
          // 读卡
          USB_DEF_READCARD : 21,
          // 标准卡
          USB_DEF_STANDCARD : 30,
          // 故障清除卡
          USB_DEF_FAILCLEAR : 31,
          // 清零卡
          USB_DEF_CLEARCARD : 32,
          // 换表卡
          USB_DEF_CHANGEMETER : 33,
          // 退水卡
          USB_DEF_BACKWATER : 34,
          // 测试卡
          USB_DEF_TESTCARD : 35,
          // 阀门卡
          USB_DEF_VALVECARD : 36,
          // 超级阀门卡
          USB_DEF_SUPERVALVE : 37,
          // 写参数卡
          USB_DEF_SETPARAM : 38,
          // 水钢印号卡
          USB_DEF_METERID : 39,
          // 水表校对卡
          USB_DEF_CHECKWATER : 40,
          // 校时卡
          USB_DEF_CHECKTIME : 41,
          // 临时充值卡
          USB_DEF_TMPPAYCARD : 42,
          // 开用户卡
          USB_DEF_MAKECARD : 60,
          //设置IP卡
          USB_DEF_IP : 44,
          // 充值
          USB_DEF_BUYGAS : 61,
          // 退卡中气，写标准卡，写用户卡
          USB_DEF_BACKCARD : 62,
          // 补卡标示
          USB_DEF_REPLACECARD : 63,
          // 是用户卡，确认写卡
          ERR_DEF_USRCARD : 220,
          // 页面标志
          USB_DEF_PAGEMARK : 240,
          // 页面激活标志
          USB_DEF_ACTIVEMARK : 241,
          // 充值界面的标志
          PAGE_MARK_BUYGAS : 1002,
          // 确认充值页面的标志
          PAGE_MARK_SHOWBUYGAS : 1003,
          // 补卡页面标识
          PAGE_MARK_REPLACE_CARD : 1004,
          // 退水卡页面标识
          PAGE_MARK_BACKWATER : 1005,
          // 退设备页面标识
          PAGE_MARK_BACKDEVICE : 1006,
          //用户开卡页面
          PAGE_MARK_MAKECARD : 1007,
          //用户退卡中水页面
          PAGE_MARK_BACKWATERCARD : 1008,
        };
        const CARD_TYPE_LIST = {
        30: '标准卡',
        31: '故障清除卡',
        32: '清零卡',
        33: '换表卡',
        34: '退水卡',
        35: '测试卡',
        36: '阀门卡',
        37: '超级阀门卡',
        38: '参数卡',
        39: '水表编号卡',
        40: '水表校对卡',
        41: '校时卡',
        42: '临时充值卡',
        60: '用户卡'
      }
      return {
        USB_DEF_INDEX,
        CARD_TYPE_LIST,
        wid:1001,
        list: [],
        visible: false,
        CardInformation: false,
        MakeACard: false,
        disableSubmit:false,
        model: {},
        data:{},
        queryParam:{},
        arg:'',
        form:{
          cardMoney:0, //卡片价格
        },
        ReturnMessages:'',
        exhibition:false,
        labelCol: { 
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' ' + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        confirmLoading: false,
        url: {
          getCardUserInfo:"jeecg-charge/meter/meterCardUpData/getCardUserInfo",  //用户制卡或写卡
          writeCard:"jeecg-charge/meter/meterCardWriteRecord/writeCard",
          sendCardInfo:"jeecg-charge/meter/meterCardUpData/sendCardInfo" //已刷卡信息传给后台
        },
        readResult:'', //读卡数据
        socket: null,
        timeOutId: null
      }
    },
    computed: {
      // i18n：弹窗标题/校验规则使用 computed 以响应语言切换
      title() {
        return this.$t('读卡')
      },
      rules() {
        return {
          cardMoney:[
            { required: true, message: this.$t('请输入卡片价格')},
            { required: false,pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9])|0)$/,message: this.$t('卡片价格有误，请输入正确的卡片价格')}
          ]
        }
      }
    },
    methods: {
      //卡操作区域
      // 连接socket
      connWebsocket(){
        try{
          if(this.visible) {
            this.socket=new WebSocket('ws://127.0.0.1:8753');//复费率端口号为:8744
          }
          
          // this.bconn = true;
        }catch(e){
          alert('error');
          return;
        }
        console.log(this.socket.readyState)
        this.socket.onopen = this.sOpen;
        this.socket.onerror = this.sError;
        this.socket.onclose= this.sClose;
        this.socket.onmessage= this.sMessage; 
      },
      sOpen(){
        console.log("WebSocket连接成功");
        // if (this.arg==1) {
          this.$message.success(this.$t("插件连接成功"));
        // } else ()
        this.bconn = true;
        // 注册页面
        this.usb_do_deal(this.wid, this.socket, this.USB_DEF_PAGEMARK,this.wid);
      },
      sError(e){
        console.log("WebSocket连接发生错误");
      },
      sMessage(msg) {
        console.log(msg);
        if (msg.data==2) {
          return
        }
        console.log(msg.data.split(","));
        if (msg.data.split(",").length>1) {
          this.parseData(msg.data);
        } else {
          if (msg.data==10) {
            this.$message.success(this.$t('写卡成功'));
          } if (msg.data==11) {
            this.$message.error(this.$t('写卡失败'));
          } if (msg.data==36) {
            this.$message.success(this.$t('阀门卡'));
          } if (msg.data==12) {
            this.$message.warning(this.$t('非本公司卡'));
          }
          this.exhibition=false;
          this.model.cardTypeName=0;
        }
      },
      sClose(e){
        console.log(e);
        console.log("-----接收消息-------" + e.code);
        // console.log(this.lockReconnect)
        this.bconn = false;
        this.reconnect();
      },
      reconnect() {
        var that = this;
        if(that.bconn) return;
        // that.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        this.timeOutId= setTimeout(function () {
          console.info("尝试重连...");
          that.connWebsocket();
          // that.lockReconnect = false;
        }, 5000);
      },
      onRefresh(){
        // window.location.reload();
        this.$confirm({
          title: this.$t('刷新当前页面?'),
          content: h => <div style="color:red;">{this.$t('刷新当前页面重置当前页面，请确定是否进行刷新操作?')}</div>,
          onOk() {
            window.location.reload();
          },
          onCancel() {
          },
          class: 'test',
        });
      },
      parseData(data){
        console.log(data);
        if(data == '') {
          return
        }
        let arr = data.split(',')
        console.log(arr)
        console.log(this.model);
        this.cardTypeName = ''
        // this.readResult = ''
        let readResult = {}

        if(this.CARD_TYPE_LIST[Number(arr[0])]) {
          this.cardTypeName = this.$t(this.CARD_TYPE_LIST[Number(arr[0])])
          readResult.cardTypeName = arr[0];
        }
        // this.readResult = `用户卡号：${arr[1]}\t\t\t\t\t\t刷卡标识：${arr[2] == 0?'已刷卡': '未刷卡'}\t\t\t\t\t\t购买次数：${arr[3]}\n剩余金额：${arr[4]}元\t\t\t\t\t\t累计用量：${arr[5]}m³\t\t\t\t\t\t单价：${Number(arr[6])/100}元/m³`
        
        readResult.cardId = arr[1];  //用户卡号
        readResult.CardIdentification = arr[2];  //刷卡标识
        readResult.BuyNumber = arr[3];  //购买次数
        console.log(readResult.CardIdentification==1);
        if (readResult.CardIdentification==1) {
          readResult.CumulativeDosage = arr[4]/1000;  //累计用量
          readResult.year = arr[5]; //年
          readResult.month = arr[6]; //月
          readResult.day = arr[7]; //日
          readResult.cardStatusword1 = arr[8];//状态字1
          readResult.cardStatusword2 = arr[9];//状态字2
          readResult.cardStatusword3 = arr[10];//状态字3
          readResult.cardStatusword4 = arr[11];//状态字4
          console.log(readResult);
          console.log("开始往后端传");
          this.queryreadcard(readResult);
        } else {
          readResult.RemainingAmount = arr[4];  //剩余金额
          readResult.CumulativeDosage = arr[5]/1000;  //累计用量
          readResult.univalence = arr[6]/100;  //单价   
        }
        console.log(readResult);
        this.readcard(readResult);
      },
      handleChange(value) {
        console.log(value)
        this.FunctionalDescription = this.$t(this.CARD_TYPE_LIST[value])
      },
      usb_do_deal(mark, socket, flags, wparam){
        // 对数据进行组合
        console.log(wparam);
        var data = flags + "," + mark + "," + wparam;
        socket.send(data);
        console.log(data);
        // this.parseData(data);
      },
      usb_do_checkWebSocket(bconn){
        if(!bconn){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('写卡器连接错误，请确保插件正常运行后，刷新页面重试!')),
            ]),
            onOk() {},
          });
        }
        return bconn;
      },
      //读卡
      read_only(){
        if(!this.usb_do_checkWebSocket(this.bconn)){
          return;
        }
        this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_READCARD, '');
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
      edit (arg,record) { 
        this.arg = arg;
        this.queryParam = Object.assign({}, record);
        this.visible = true;
        this.connWebsocket();//卡操作  
        if (arg!=1) {
          this.querygetCardUserInfo();
        }
      },
      readcard(readResult){
        this.model = Object.assign({}, readResult);
        this.querygetCardUserInfo();
        console.log(this.model);
      },
      queryreadcard(readResult){  //已刷卡信息传给后台
      console.log(readResult);
      console.log("正在开始往后端传");
        let cardSwipDate =Number(2000)+Number(readResult.year)+'-'+readResult.month+'-'+readResult.day
        let params = {}
        params.cardId = readResult.cardId;
        params.cardBuyTimes = readResult.BuyNumber;
        params.cardStatusword1 = readResult.cardStatusword1;
        params.cardStatusword2 = readResult.cardStatusword2;
        params.cardStatusword3 = readResult.cardStatusword3;
        params.cardStatusword4 = readResult.cardStatusword4;
        params.cardSumFlow = readResult.CumulativeDosage*1000;
        params.cardSwipDate = cardSwipDate;
        postAction(this.url.sendCardInfo, params).then((res) => {
          if(res.success){
          console.log("你传过去呢");
          }
        })
      },
      querygetCardUserInfo() {  //用户制卡或写卡查询
      console.log(this.arg);
      console.log(this.queryParam);
        let params = {}
        if (this.arg==1) { //卡操作
          params.cardId = this.model.cardId;
        } else {
          params.userKeyId = this.queryParam.id;
        }
        console.log(params);
        getAction(this.url.getCardUserInfo, params).then((res) => {
          if(res.success){
           if (res.result == null) {
             this.$message.error(this.$t('系统中没有该用户信息'));
             console.log("系统中没有该用户信息");
             this.exhibition= false;
           } else {
            this.data = res.result;
            this.exhibition= true;
           }
          }
        })
      },
      modalFormOk() {
        this.close()
      },
      querywriteCard() { 
      console.log(this.data);
      console.log(this.model);
        let params = {}
        params.userKeyId = this.data.userKeyId;
        params.meterId = this.data.meterId;
        if (this.arg==2) {
          let cardId = this.data.meterId.slice(2);
          params.cardId = cardId;
          this.data.cardId = cardId;
          params.cardMoney = this.form.cardMoney;
        } else {
          params.cardId = this.data.cardId;
          params.buyTimes = this.data.userPayTimes;
        }
        
        params.remainMoney =this.data.userAccountNum;
        params.sumFlow = this.data.userCalNum;
        params.waterPrice = this.data.wtTotalPrice;
        // console.log(this.data.meterId);
        // let cardId =this.data.meterId.split(",")
        // console.log(this.data.meterId.slice(2));
        console.log(params);
        let data = params
        postAction(this.url.writeCard, params).then((res) => {
          if(res.success){
            console.log(res.code);
            // if (this.arg==2) {
              this.write_card(this.data);
            // } else {
              // this.write_card(this.data);
            // }
          }
          setTimeout(() => {
            this.handleCancel();
           },1000)
        })
      },
      //写卡
      write_card(data) {
        console.log(data);
        var index='';
        if (this.arg==2) {
          index = 60;
        } else {
          index = this.model.cardTypeName
        }
        console.log(parseInt(index));
        switch(parseInt(index))
        {
          case 60:
            //用户卡
            console.log(data);
            let params = '';
            params = data.cardId+','+data.userPayTimes+','+data.userAccountNum+','+(data.userCalNum*1000).toFixed(0)+','+(data.wtTotalPrice*100).toFixed(0)
            console.log(params);
            this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_MAKECARD, params);
            break;
        }
      },
      showModal(num) {
        console.log(num);
        if (num==1) {
          if(this.data.meterType !=='WN100') {
            this.$message.error(this.$t("请前往缴费大厅充值"));
          }else{
            this.CardInformation = true;
          }
        }else if (num==3) {
          if(this.data.userPayState === 0) {
            this.$message.error(this.$t("该用户不允许缴费！"));
          }else if(this.data.meterType !=='WN100') {
            this.$message.error(this.$t("请前往缴费大厅充值"));
          }else{
            this.handleCancel();
            this.$refs.modalForm.edit(this.data);
            this.$refs.modalForm.title = this.$t("用户卡充值");
          }
          
        }else if (num==2) {
          if(!this.usb_do_checkWebSocket(this.bconn)){
          return;
          }
          console.log("进对一步");
          this.$refs.form.validate(valid => {
            if (valid) {
              console.log(valid);
              console.log("进成功");
              this.MakeACard = true;
            }
          })
        }
      },
      MakeACardOk(e){
        console.log(e);
        this.querywriteCard();
        setTimeout(() => {
          this.MakeACard = false;
        },1000)
      },
      CardInformationOk(e) {
        console.log(e);
        this.querywriteCard();
        setTimeout(() => {
          this.CardInformation = false;
        },1000)
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.model.cardTypeName = 0;
        this.form = this.$options.data.call(this).form
        this.exhibition = false;
        this.visible = false;
        clearTimeout(this.timeOutId)
        this.timeOutId = null
        this.socket = null
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
.label >>> .content{
  color:red;
}
</style>